import type {
  NavigationSubmenuItem,
  ProfileSubmenuVisibilityOptions,
} from './types'

export const isB2BProfileSubmenuItemVisible = (
  submenuItem: NavigationSubmenuItem,
  options: ProfileSubmenuVisibilityOptions
): boolean => {
  switch (submenuItem.type) {
    case 'ActAs':
      return options.isAdminOrHigher || options.isActAs
    case 'MyAccount':
      return options.isAdminOrHigher && options.hasAccountId
    case 'Accounts':
      return (
        options.hasCurrentUser &&
        (
          options.isStaff ||
          (options.isAdminOrHigher && (options.isPartner || options.isFranchise))
        )
      )
    case 'Billing':
      return options.hasCurrentUser && options.isAllowedToPromote
    case 'GetMobileApp':
      return !options.isWebView
    case 'SwitchToHome':
      return !options.isActAs
    default:
      return true
  }
}
